import { ValidationError } from './ValidationError';
import {
  ISendValidationCodeResponse200,
  TSendValidationCodeResponse,
} from '../../../repositories/sms/v2/send-validation-code';

interface IPhoneValidationError {
  code: string;
  message: string;
}

export function assertError(response: TSendValidationCodeResponse): asserts response is ISendValidationCodeResponse200 {
  if (response.statusCode !== 400) {
    return;
  }

  const phoneFormatError = response.response.errors?.find(
    (error: IPhoneValidationError) => error.code === 'phone_number_is_invalid',
  );

  if (phoneFormatError) {
    throw new ValidationError({
      message: (phoneFormatError as IPhoneValidationError).message,
      domain: 'requestPhoneValidationCode',
      errors: {
        phoneNumberIsInvalid: (phoneFormatError as IPhoneValidationError).message,
      },
    });
  } else {
    throw new ValidationError({
      message: response.response.message || 'Попробуйте ещё раз.',
      domain: 'requestPhoneValidationCode',
      errors: {
        tryValidationCodeLater: response.response.message || 'Попробуйте ещё раз.',
      },
    });
  }
}
